import './App.css';
import WhatsAppButton from './components/whatsappbutton';
// import Navbar from './components/Navbar';


// {/* main pages */}
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Logobar from './components/logobar';
import Header from './components/header';
import Home from './components/home';
import Footer from './components/Footer';
import Abouts from './components/abouts';
import Contact from './components/contact'
import Blog from './components/blog'
import Career from './components/career'
import Events from './components/events'
// import Calculator from './components/calculator'
import Contentdown from './components/Contentdown';

// {/* partner divides */ }
import AmazonATESPartner from './partner/amazon-ates-partner'
import AmazonAffliateGlobalPartner from './partner/amazon-affiliate-global-partner'
import FlipkartPartner from './partner/flipkart-spn-partner'
import JiomartPartner from './partner/jiomart-partner'
import Meeshopartner from './partner/meesho-partner'

// {/* OurServices Domestic divides */}
import AmazonAccountManagement from './domestic-services/amazon-account-management'
import FlipkartAccountManagement from './domestic-services/flipkart-account-management'
import MeeshoAccountManagement from './domestic-services/meesho-account-management'
import JiomartAccountManagement from './domestic-services/jiomart-account'
import PurpleAccountManagement from './domestic-services/purple-account'
import GlowRoadAccountManagement from './domestic-services/glow-road'
// import LimeRoadAccountManagement from './domestic-services/lime-road'

// {/* OurServices International divides */}
import AlibabaAccountManagement from './international-services/alibaba'
import AmazonGlobalAccountManagement from './international-services/amazon-global'
import EbayAccountManagement from './international-services/ebay'
import EtsyAccountManagement from './international-services/etsy'
import WalmartAccountManagement from './international-services/walmart'

// {/* OurServices International divides */}
import FbaServices from './fba-services/fba-shipment'

//  {/* OurServices  Listing/Cataloging divides */}
import AmazonListingServices from './listing-services/amazon'
import FlipkartListingServices from './listing-services/flipkart'
import MeeshoListingServices from './listing-services/meesho'
import JiomartListingServices from './listing-services/jiomart'
import EtsyListingServices from './listing-services/etsy'
import WalmartListingServices from './listing-services/walmart'
import PurpleListingServices from './listing-services/purple'
import GlowRoadListingServices from './listing-services/glow-road'

// {/* OurServices  Advertisement/Marketing divides */}
import AmazonAdvertisementServices from './advertisement-services/amazon'
import FlipkartAdvertisementServices from './advertisement-services/flipkart'
import MeeshoAdvertisementServices from './advertisement-services/meesho'
import AmazonGlobalAdvertisementServices from './advertisement-services/amazonglobal'
import EbayAdvertisementServices from './advertisement-services/ebay'

// {/* OurServices  Sales Boost/Rating & Reviews divides */}
import AmazonSalesBoostServices from './sales-services/amazon'
import FlipkartSalesBoostServices from './sales-services/flipkart'
import MeeshoSalesBoostServices from './sales-services/meesho'
import JiomartSalesBoostServices from './sales-services/jiomart'
import ShopifySalesBoostServices from './sales-services/shopify'
import EtsySalesBoostServices from './sales-services/etsy'
import WalmartSalesBoostServices from './sales-services/walmart'

// {/* Services training */}
import Training from './services/training'

// {/* OurServices  Digital Marketing divides */ }
import SMOMarketing from './marketing-services/smo'
import SEO from './marketing-services/seo'
import EMailMarketing from './marketing-services/email'
import SEMMarketing from './marketing-services/sem'
import SMMMarketing from './marketing-services/smm'
import AffiliateMarketing from './marketing-services/affliate'

// {/* Free Onboarding divides */ }
import AmazonRegistration from './registration-services/amazon'
import AmazonGlobalRegistration from './registration-services/amazon-global'
import MeeshoRegistration from './registration-services/meesho'
import JiomartRegistration from './registration-services/jiomart'
import FlipkartRegistration from './registration-services/flipkart'
import GlowRoadRegistration from './registration-services/glowroad'


function App() {
  return (
    <>

      {/* <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route exact path="/blog" element={<Blog />}></Route>
          <Route exact path="/contact" element={<Contact />}></Route>
          {/* Nested route */}
      {/* <Route exact path="/career" element={<Career />}></Route>
      <Route exact path="/events" element={<Events />}></Route>
      <Route exact path="/abouts" element={<Abouts />}></Route> */}
      {/* </Routes >
      </Router > */ }

      {/* <Navbar /> */}
      <Logobar />
      <Header />
      {/* <div className='bg-indigo-600 w-full h-screen mt-50'>


      </div> */}
      <Router>
        <Routes >
          {/* main pages */}
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/events" element={<Events />} />
          <Route path="/abouts" element={<Abouts />} />
          {/* <Route path='/calculator' element={<Calculator />} /> */}


          {/* partner divides */}
          <Route path='/partner/amazon-ates-partner' element={<AmazonATESPartner />} />
          <Route path="/partner/amazon-affiliate-global-partner" element={<AmazonAffliateGlobalPartner />} />
          <Route path='/partner/flipkart-spn-partner' element={<FlipkartPartner />} />
          <Route path='/partner/jiomart-partner' element={<JiomartPartner />} />
          <Route path='/partner/meesho-partner' element={<Meeshopartner />} />

          {/* OurServices Domestic divides */}
          <Route path='/domestic-services/amazon-account-management' element={<AmazonAccountManagement />} />
          <Route path="/domestic-services/flipkart-account-management" element={<FlipkartAccountManagement />} />
          <Route path='/domestic-services/meesho-account-management' element={<MeeshoAccountManagement />} />
          <Route path='/domestic-services/jiomart-account' element={<JiomartAccountManagement />} />
          <Route path='/domestic-services/purple-account' element={<PurpleAccountManagement />} />
          <Route path='/domestic-services/glow-road' element={<GlowRoadAccountManagement />} />
          {/* <Route path='/domestic-services/lime-road' element={<LimeRoadAccountManagement />} /> */}

          {/* OurServices International divides */}
          <Route path='/international-services/amazon-global' element={<AmazonGlobalAccountManagement />} />
          <Route path="/international-services/ebay" element={<EbayAccountManagement />} />
          <Route path='/international-services/etsy' element={<EtsyAccountManagement />} />
          < Route path='/international-services/walmart' element={<WalmartAccountManagement />} />
          < Route path='/international-services/alibaba' element={<AlibabaAccountManagement />} />

          {/* Fba Services */}
          < Route path='/fba-services/fba-shipment' element={<FbaServices />} />

          {/* OurServices  Listing/Cataloging divides */}
          <Route path='/listing-services/amazon' element={<AmazonListingServices />} />
          <Route path="/listing-services/flipkart" element={<FlipkartListingServices />} />
          <Route path='/listing-services/meesho' element={<MeeshoListingServices />} />
          <Route path='/listing-services/jiomart' element={<JiomartListingServices />} />
          <Route path='/listing-services/etsy' element={<EtsyListingServices />} />
          <Route path='/listing-services/walmart' element={<WalmartListingServices />} />
          <Route path='/listing-services/purple' element={<PurpleListingServices />} />
          <Route path='/listing-services/glow-road' element={<GlowRoadListingServices />} />

          {/* OurServices  Advertisement/Marketing divides */}
          <Route path='/advertisement-services/amazon' element={<AmazonAdvertisementServices />} />
          <Route path="/advertisement-services/flipkart" element={<FlipkartAdvertisementServices />} />
          <Route path='/advertisement-services/meesho' element={<MeeshoAdvertisementServices />} />
          <Route path='/advertisement-services/amazonglobal' element={<AmazonGlobalAdvertisementServices />} />
          <Route path='/advertisement-services/ebay' element={<EbayAdvertisementServices />} />

          {/* OurServices  Sales Boost/Rating & Reviews divides */}
          <Route path='/sales-services/amazon' element={<AmazonSalesBoostServices />} />
          <Route path="/sales-services/flipkart" element={<FlipkartSalesBoostServices />} />
          <Route path='/sales-services/meesho' element={<MeeshoSalesBoostServices />} />
          <Route path='/sales-services/jiomart' element={<JiomartSalesBoostServices />} />
          <Route path='/sales-services/shopify' element={<ShopifySalesBoostServices />} />
          <Route path='/sales-services/etsy' element={<EtsySalesBoostServices />} />
          <Route path='/sales-services/walmart' element={<WalmartSalesBoostServices />} />

          {/*Sales Services */}
          < Route path='/services/training' element={<Training />} />

          {/* OurServices  Digital Marketing divides */}
          <Route path='/marketing-services/smo' element={<SMOMarketing />} />
          <Route path="/marketing-services/seo" element={<SEO />} />
          <Route path='/marketing-services/email' element={<EMailMarketing />} />
          <Route path='/marketing-services/sem' element={<SEMMarketing />} />
          <Route path='/marketing-services/smm' element={<SMMMarketing />} />
          <Route path='/marketing-services/affliate' element={<AffiliateMarketing />} />

          {/* Free Onboarding divides */}
          <Route path='/registration-services/amazon' element={<AmazonRegistration />} />
          <Route path="/registration-services/amazon-global" element={<AmazonGlobalRegistration />} />
          <Route path='/registration-services/meesho' element={<MeeshoRegistration />} />
          <Route path='/registration-services/jiomart' element={<JiomartRegistration />} />
          <Route path='/registration-services/flipkart' element={<FlipkartRegistration />} />
          <Route path='//registration-services/glowroad' element={<GlowRoadRegistration />} />

        </Routes >
      </Router >
      <WhatsAppButton />
      <Contentdown />
      <Footer />
    </>
  );
}

export default App;
